import React, { useState } from 'react';
import './Header.css';
import { Link } from '../router';
import { NAV_ITEMS, NavChild } from '../links';

interface HeaderProps {
  path: string;
}

const Header: React.FC<HeaderProps> = ({ path }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const close = () => setMenuOpen(false);

  const renderChild = (child: NavChild) => {
    if (child.to) {
      return (
        <Link to={child.to} onClick={close}>
          {child.label}
        </Link>
      );
    }
    // Separate pages (e.g. the workshop page) and external sites are plain links.
    return (
      <a
        href={child.href}
        onClick={close}
        {...(child.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
      >
        {child.label}
      </a>
    );
  };

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="logo" onClick={close}>
          <img src="/icon@4x.png" alt="KinezioSomatic logo" className="logo-icon" />
          <span className="brand-title">Hanna Kinez KinesioSomatic</span>
        </Link>

        <button
          className="menu-toggle"
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span />
          <span />
          <span />
        </button>

        <nav className={`nav ${menuOpen ? 'nav--open' : ''}`}>
          <ul>
            {NAV_ITEMS.map((item) => (
              <li key={item.to} className={item.children ? 'has-dropdown' : undefined}>
                <Link to={item.to} className={path === item.to ? 'active' : ''} onClick={close}>
                  {item.label}
                </Link>
                {item.children && (
                  <ul className="dropdown">
                    {item.children.map((child) => (
                      <li key={child.label}>{renderChild(child)}</li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
